import { ICountryDetailDTO } from "api/swagger/ApiClient";
import { EmailAddressWrapper, SystemUserContactWrapper, SystemUserWrapper } from "model/support-types";

export interface CountryDetailData extends ICountryDetailDTO {
  genericEmailAddressesWrapper: EmailAddressWrapper[];
  approversWrapper: SystemUserWrapper[];
  contactsWrapper: SystemUserContactWrapper[];
}
